var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-card", style: { backgroundColor: _vm.coldColor } },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-start" },
        [
          _c("div", { staticClass: "d-flex flex-column" }, [
            _c("span", { staticClass: "h4 font-weight-bold" }, [
              _vm._v(
                "#" +
                  _vm._s(_vm.order.id.toString().slice(-3)) +
                  " - " +
                  _vm._s(
                    _vm.order.customer &&
                      _vm.getFirstName(_vm.order.customer.name)
                  )
              ),
            ]),
          ]),
          _c("span", { staticClass: "badge badge-cold" }, [
            _vm._v(_vm._s(_vm.coldLabel)),
          ]),
        ]
      ),
      _c("div", { staticClass: "d-flex justify-content-end" }, [
        _vm.waitingTime !== null
          ? _c("span", { staticClass: "small" }, [
              _vm._v("Tempo de espera: " + _vm._s(_vm.waitingTime) + " min"),
            ])
          : _vm._e(),
      ]),
      _c(
        "ul",
        { staticClass: "mb-1" },
        _vm._l(_vm.order.items, function (item) {
          return _c("li", { key: item.id }, [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(item.quantity) + "x"),
            ]),
            _vm._v(" - "),
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(item.sku && item.sku.name)),
            ]),
            _vm._v(" - "),
            _c("span", [_vm._v(_vm._s(_vm._f("currency")(item.netValue)))]),
          ])
        }),
        0
      ),
      _c("div", { staticClass: "d-flex justify-content-end mb-0" }, [
        _c("span", { staticClass: "font-weight-bold" }, [
          _vm._v("Total: " + _vm._s(_vm._f("currency")(_vm.order.netValue))),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c(
            "div",
            { staticClass: "order-card-footer mt-1" },
            [
              _vm.order.preparationStatus === "Pending"
                ? _c(
                    "b-button",
                    {
                      staticClass: "font-weight-bold",
                      attrs: { variant: "primary", size: "lg", block: "" },
                      on: { click: _vm.onPrintPrepare },
                    },
                    [_vm._v(" Iniciar Preparo ")]
                  )
                : _vm._e(),
              _vm.order.preparationStatus === "Preparing"
                ? _c(
                    "b-button",
                    {
                      staticClass: "font-weight-bold",
                      attrs: { variant: "primary", size: "lg", block: "" },
                      on: { click: _vm.onMarkReady },
                    },
                    [_vm._v(" Finalizar Preparo ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }